













// @ts-nocheck
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import mixins from 'vue-typed-mixins'
import linkAdsListMixin from '@/components/Mixins/linkAdsList'

let vm = null
export default mixins(linkAdsListMixin<TopWelfareCard>()).extend({
  components: {
    swiper,
    swiperSlide
  },

  props: {
    contentKey: String,
    contentList: Array,
    index: Number,
    PVIformat: String,
    clickIformat: String
  },
  created() {
    vm = this
  },
  mounted() {
    this.reportAdsPV(
      this.index,
      {
        groupId: this.contentList[0]?.groupId_busId.split('_')[0]
      },
      this.PVIformat
    )
    this.$nextTick(() => {
      this.swiperOptions.coverflowEffect.stretch = this.$refs.bannerCard?.offsetWidth * 0.373 || 0
    })
  },
  computed: {
    mappedContentList() {
      return this.contentList
    }
  },
  watch: {
    mappedContentList() {
      this.swiperOptions.loopedSlides = this.mappedContentList.length
      this.swiperKey = Math.random()
        .toString(36)
        .substr(2)
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1.1,
        centeredSlidesBounds: true,
        effect: 'coverflow',
        centeredSlides: true,
        loop: true,
        loopedSlides: 0,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 140,
          modifier: 2,
          slideShadows: true
        },

        on: {
          slideChange() {
            const realIndex = Number(this.realIndex)
            vm.reportAdsPV(
              realIndex + vm.index,
              {
                groupId: vm.contentList[realIndex]?.groupId_busId.split('_')[0]
              },
              vm.PVIformat
            )
          },

          click() {
            vm.reportAdsPV(
              vm.index + this.realIndex,
              {
                groupId: vm.contentList[this.realIndex]?.groupId_busId.split('_')[0]
              },
              vm.clickIformat
            )
            if (vm.contentList[this.realIndex]?.url) {
              window.location.href = vm.contentList[this.realIndex].url
            }
          }
        }
      },
      swiperKey: Math.random()
        .toString(36)
        .substr(2)
    }
  }
})
